import { defineMessages } from "react-intl"

export default defineMessages({
  headerGamesPlayed: {
    id: "app.pages.profile.GamesPlayed.headerGamesPlayed",
  },
  descriptionGamesPlayed: {
    id: "app.pages.profile.GamesPlayed.descriptionGamesPlayed",
  },
  poweredByIGDB: {
    id: "app.pages.profile.GamesPlayed.poweredByIGDB",
  },
  totalAddedGames: {
    id: "app.pages.profile.GamesPlayed.totalAddedGames",
  },
  addGame: {
    id: "app.pages.profile.GamesPlayed.addGame",
  },
  descriptionSearch: {
    id: "app.pages.profile.GamesPlayed.descriptionSearch",
  },
  noGamesFound: {
    id: "app.pages.profile.GamesPlayed.noGamesFound",
  },
})

